import { useMemo } from "react";
import { FieldValues } from "react-hook-form";

import { SelectProps as SelectFieldProps } from "components/ui/select/Select";
import SkeletonText from "components/ui/skeleton/SkeletonText";
import { useLeadWorkflow } from "../../../../lib/hooks/api/leads/useLeadWorkflow";
import { ExtendedStageOption, processTransitions } from "../../../shared/stage/utils";
import { StageSelect } from "./StageSelect";

/* New LeadStageSelect component */
export function LeadStageSelect<TFieldValues extends FieldValues = FieldValues>(
  props: Omit<SelectFieldProps<TFieldValues>, "children"> & { truncate?: boolean },
) {
  const { data, isLoading } = useLeadWorkflow();

  const flatOptions: ExtendedStageOption[] = useMemo(() => {
    if (!data?.transitions) return [];
    const grouped = processTransitions(data.transitions);
    return grouped.flatMap((group) => group.options);
  }, [data]);

  if (isLoading) {
    return <SkeletonText width={"200px"} />;
  }

  return <StageSelect {...props} options={flatOptions} />;
}
